import { AlertIcon, IconComponent, WarningIcon } from '@farol-ds/react'

export const PUBLISHING_RULES_URL = `www.jusbrasil.com.br/artigos/111561143/quais-sao-as-regras-para-publicacao-de-textos-no-jusbrasil` // eslint-disable-line max-len

interface BannerConfig {
  title: string
  type: 'warning' | 'critical'
  icon: IconComponent
}

export const CONDITION_MAP = new Map<string | null, BannerConfig>([
  [
    'REVIEW',
    {
      title: 'Aguardando Moderação',
      type: 'warning',
      icon: WarningIcon,
    },
  ],
  [
    'REPROVED',
    {
      title: 'Documento Reprovado',
      type: 'critical',
      icon: AlertIcon,
    },
  ],
  [
    'CREATOR_ONLY',
    {
      title: 'Documento Oculto',
      type: 'critical',
      icon: AlertIcon,
    },
  ],
  [
    'PRIVATE',
    {
      title: 'Documento Oculto',
      type: 'critical',
      icon: AlertIcon,
    },
  ],
])
